// TODO(E): State needs to be tied to a player and reset if players change and using a single view for all
export const PersistedViewState = key => {
  return {
    fetch: () => {
      try {
        const value = localStorage.getItem(key);
        if (!value) {
          return null;
        }
        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    },
    save: value => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {}
    },
  };
};

export const SessionStateAccessor = key => ({
  fetch: () => {
    try {
      const value = sessionStorage.getItem(key);
      if (!value) {
        return null;
      }
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },
  save: value => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  },
  clear: () => {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  },
});
